import {
    SET_NOTE_FRAIS_REQUEST_LOADING,
    CLEAR_NOTE_FRAIS_REQUEST_MESSAGE,

    GET_MY_NOTE_FRAIS_REQUESTS_SUCCESS,
    GET_MY_NOTE_FRAIS_REQUESTS_FAIL,

    CREATE_NOTE_FRAIS_REQUEST_SUCCESS,
    CREATE_NOTE_FRAIS_REQUEST_FAIL,

    CANCEL_NOTE_FRAIS_REQUEST_SUCCESS,
    CANCEL_NOTE_FRAIS_REQUEST_FAIL,

    UPDATE_NOTE_FRAIS_REQUEST_SUCCESS,
    UPDATE_NOTE_FRAIS_REQUEST_FAIL,

    GET_MANAGER_NOTE_FRAIS_INBOX_SUCCESS,
    GET_MANAGER_NOTE_FRAIS_INBOX_FAIL,

    MANAGER_NOTE_FRAIS_DECISION_SUCCESS,
    MANAGER_NOTE_FRAIS_DECISION_FAIL,

    GET_MANAGER_NOTE_FRAIS_HISTORY_SUCCESS,
    GET_ADMIN_NOTE_FRAIS_INBOX_SUCCESS,
    GET_ADMIN_NOTE_FRAIS_INBOX_FAIL,

    ADMIN_NOTE_FRAIS_DECISION_SUCCESS,
    ADMIN_NOTE_FRAIS_DECISION_FAIL,

    GET_ADMIN_NOTE_FRAIS_HISTORY_SUCCESS,
    GET_ADMIN_NOTE_FRAIS_HISTORY_FAIL,

    MARQUER_NOTE_FRAIS_REMBOURSE_SUCCESS,
    MARQUER_NOTE_FRAIS_REMBOURSE_FAIL,

    GET_NOTE_FRAIS_EN_ATTENTE_REMBOURSEMENT_SUCCESS,
    GET_NOTE_FRAIS_EN_ATTENTE_REMBOURSEMENT_FAIL,

    GET_NOTE_FRAIS_BY_ORDRE_MISSION_SUCCESS,
    GET_NOTE_FRAIS_BY_ORDRE_MISSION_FAIL,
    normalizeError, GET_MANAGER_NOTE_FRAIS_HISTORY_FAIL,
} from "../actions/noteDeFraisRequestActions";

const initialState = {
    myRequests: [],
    managerInbox: [],
    managerHistory: [],
    adminInbox: [],
    adminHistory: [],
    enAttenteRemboursement: [],
    byOrdreMission: [],
    loading: false,
    error: null,
    message: null,
    success: false,
};
const toStr = (x) => normalizeError(x, "");
export default function noteDeFraisRequestsReducer(state = initialState, action) {
    switch (action.type) {
        case SET_NOTE_FRAIS_REQUEST_LOADING:
            return { ...state, loading: !!action.payload };
        case CLEAR_NOTE_FRAIS_REQUEST_MESSAGE:
            return { ...state, error: "", message: "" };

        // ========= MY REQUESTS =========
        case GET_MY_NOTE_FRAIS_REQUESTS_SUCCESS:
            return { ...state, myRequests: action.payload || [], error: "" };

        case GET_MY_NOTE_FRAIS_REQUESTS_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= CREATE =========
        case CREATE_NOTE_FRAIS_REQUEST_SUCCESS:
            return {
                ...state,
                message: "Note de frais envoyée avec succès",
                error: "",
            };

        case CREATE_NOTE_FRAIS_REQUEST_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= CANCEL =========
        case CANCEL_NOTE_FRAIS_REQUEST_SUCCESS:
            return { ...state, message: "Note de frais annulée avec succès", error: "" };

        case CANCEL_NOTE_FRAIS_REQUEST_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= UPDATE =========
        case UPDATE_NOTE_FRAIS_REQUEST_SUCCESS:
            return { ...state, message: "Note de frais modifiée avec succès", error: "" };

        case UPDATE_NOTE_FRAIS_REQUEST_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= MANAGER INBOX =========
        case GET_MANAGER_NOTE_FRAIS_INBOX_SUCCESS:
            return { ...state, managerInbox: action.payload || [], error: "" };

        case GET_MANAGER_NOTE_FRAIS_INBOX_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= MANAGER DECISION =========
        case MANAGER_NOTE_FRAIS_DECISION_SUCCESS:
            return { ...state, message: "Décision envoyée", error: "" };

        case MANAGER_NOTE_FRAIS_DECISION_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= MANAGER HISTORY =========
        case GET_MANAGER_NOTE_FRAIS_HISTORY_SUCCESS:
            return { ...state, managerHistory: action.payload || [], error: "" };

        case GET_MANAGER_NOTE_FRAIS_HISTORY_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= ADMIN INBOX =========
        case GET_ADMIN_NOTE_FRAIS_INBOX_SUCCESS:
            return { ...state, adminInbox: action.payload || [], error: "" };

        case GET_ADMIN_NOTE_FRAIS_INBOX_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= ADMIN DECISION =========
        case ADMIN_NOTE_FRAIS_DECISION_SUCCESS:
            return { ...state, message: "Décision RH envoyée", error: "" };

        case ADMIN_NOTE_FRAIS_DECISION_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= ADMIN HISTORY =========
        case GET_ADMIN_NOTE_FRAIS_HISTORY_SUCCESS:
            return { ...state, adminHistory: action.payload || [], error: "" };

        case GET_ADMIN_NOTE_FRAIS_HISTORY_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= REMBOURSEMENT =========
        case MARQUER_NOTE_FRAIS_REMBOURSE_SUCCESS:
            return { ...state, message: "Note de frais marquée comme remboursée", error: "" };

        case MARQUER_NOTE_FRAIS_REMBOURSE_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= EN ATTENTE REMBOURSEMENT =========
        case GET_NOTE_FRAIS_EN_ATTENTE_REMBOURSEMENT_SUCCESS:
            return { ...state, enAttenteRemboursement: action.payload || [], error: "" };

        case GET_NOTE_FRAIS_EN_ATTENTE_REMBOURSEMENT_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= BY ORDRE MISSION =========
        case GET_NOTE_FRAIS_BY_ORDRE_MISSION_SUCCESS:
            return { ...state, byOrdreMission: action.payload || [], error: "" };

        case GET_NOTE_FRAIS_BY_ORDRE_MISSION_FAIL:
            return { ...state, error: toStr(action.payload) };

        default:
            return state;
    }}